const photoTemplate = require('templates/photos/single-photo.hbs');

if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }


L2H.SinglePhotoView = class SinglePhotoView {
  constructor(photo, $container, options) {
    this.photo = photo;
    this.$container = $container;
    this.options = options;
    this.linkTarget = this.options.openShopableLinksInNewWindow ? "_blank" : "_self";
    this.shopablesView = new L2H.ShopablesView(this.photo.shopables, this.$container, this.options);
    this.trackers = [];

    this.trackers.push(new L2H.Tracker(L2H.clientTrackerID, `${L2H.permalink}|shared-photo-page`, L2H.rootURL));
    this.trackers.push(new L2H.InternalTracker(L2H.permalink, 'shared-photo-page', L2H.appURL));

    for (let tracker of Array.from(this.trackers)) { tracker.trackPageView(); }
    this.bindEvents();
  }

  render() {
    const context = {
      photo: this.photo,
      assetHost: L2H.assetHost,
      url: this.photo.shopables.length === 1 ? this.photo.shopables[0].url : undefined,
      linkTarget: this.linkTarget,
      aspectAsPercentage: (this.photo.height / this.photo.width) * 100,
      features: L2H.features,
      preferences: L2H.preferences
    };

    const renderedPhoto = photoTemplate(context);
    this.$container.html(renderedPhoto);
    this.shopablesView.render();
  }

  bindEvents() {
    const self = this;
    return this.$container.on('click', '.trackable-link', function(e) {
      const $link = $(this);
      const shopableID = $link.data('shopable-id');
      const url = $link.attr('href');

      if (L2H.debug) { console.log(`L2H DEBUG: you clicked on shopable with id: ${shopableID}`); }
      Array.from(self.trackers).map((tracker) => tracker.trackShopableClick(url, self.photo.id, shopableID));
    });

  }
}
